// Vaste link voor de globale leisure-locatiekiezer (templates/_partials/leisure-popup.twig).
//   #reserveer-leisure               → popup met alle leisure-clubs
//   #reserveer-leisure/trampoline    → enkel clubs met de activiteit met slug "trampoline"
// Redacteurs zetten die link in eender welk linkveld of tekstlink; wij vangen de klik op
// en dispatchen `open-leisure` (Alpine `x-on:open-leisure.window` in location-picker.twig).

const PREFIX = "#reserveer-leisure";

function activityFromHash(hash) {
	if (!hash || !hash.startsWith(PREFIX)) return undefined;
	const rest = hash.slice(PREFIX.length).replace(/^[/-]/, "");
	return rest ? decodeURIComponent(rest) : null;
}

function openLeisure(activity) {
	window.dispatchEvent(new CustomEvent("open-leisure", { detail: { activity } }));
}

document.addEventListener("click", (e) => {
	const link = e.target.closest?.('a[href*="' + PREFIX + '"]');
	if (!link) return;
	// Enkel links naar DEZE pagina afhandelen; een link naar een andere pagina + hash
	// navigeert gewoon en opent daar via de hash-check hieronder.
	const samePage = link.pathname === window.location.pathname && link.host === window.location.host;
	const activity = activityFromHash(link.hash);
	if (activity === undefined || !samePage) return;
	e.preventDefault();
	openLeisure(activity);
});

// Pagina geladen met de hash (gedeelde link, of link vanaf een andere pagina)
const initial = activityFromHash(window.location.hash);
if (initial !== undefined) {
	// Alpine is al gestart (alpine.js wordt vóór dit bestand geïmporteerd); listeners staan klaar.
	window.setTimeout(() => openLeisure(initial), 0);
}
